import React, { Component } from "react";

import { DatePicker } from "antd";
const { MonthPicker, RangePicker } = DatePicker;
import moment from "moment";

class TCDatePickerFilter extends Component {
  onChange = dates => {
    this.props.onFilterSet({
      startDate: dates[0],
      endDate: dates[1]
    });
  };

  render() {
    let values = [];
    if (this.props.filterOptions)
      values = [
        this.props.filterOptions.startDate,
        this.props.filterOptions.endDate
      ];

    return (
      <span>
        <RangePicker
          ranges={{
            "Last 30 days": [moment().subtract(30, "days"), moment()],
            "Last 7 days": [moment().subtract(7, "days"), moment()],
            "This month": [moment().startOf("month"), moment()],
            "This week": [moment().startOf("week"), moment()]
          }}
          onChange={this.onChange}
          value={values}
        />
      </span>
    );
  }
}
export default TCDatePickerFilter;
